import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ParticipationComponent } from './participation/participation.component';
import { ControlsModule } from './pm-controls/controls.module';
import { PreviewData, CommonSetting, SignUp, OfflineSurvey } from './common-class/survey';
import { QuestionStringPipe } from './_pipe/question-string.pipe';
import { MatrixGroupPipe,MatrixGroupPipeEdit } from './_pipe/matrix-group.pipe';
import { MatrixPipe, MatrixPipeEdit } from './_pipe/matrix-data.pipe';
import { GroupPipe, GroupPipeEdit } from './_pipe/group.pipe';
import { MultiGroupPipe,MultiGroupPipeEdit } from './_pipe/multi-group.pipe';
import { DestroyDirective } from './_directives/destroy.directive';
import { CustomErrorsHandlerService } from './_services/custom-errors-handler.service';
import { PipeModule } from './_pipe/pipe.module';
import { SurveyDecodeComponent } from './survey-redirect/survey-decode/survey-decode.component';
import { PreviewComponent } from './Preview/preview/preview.component';
import { PrintResponseComponent } from './print-response/print-response.component';
import { SocialAuthenticationComponent } from './Social/social-authentication/social-authentication.component';
import { ShortKeyComponent } from './survey-redirect/short-key/short-key.component';
import { EditResponseComponent } from './edit-response/edit-response.component';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { DatePicker } from 'primeng/datepicker';


@NgModule({
  declarations: [
    AppComponent,
    ParticipationComponent,
    QuestionStringPipe,
    MatrixGroupPipe,
    MatrixPipe,
    MatrixPipeEdit,
    MatrixGroupPipe,
    MatrixGroupPipeEdit,
    GroupPipe,
    GroupPipeEdit,
    MultiGroupPipe,
    MultiGroupPipeEdit,
    DestroyDirective,
    SurveyDecodeComponent,
    PreviewComponent,
    PrintResponseComponent,
    SocialAuthenticationComponent,
    EditResponseComponent,
    ShortKeyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ControlsModule,
    PipeModule,
    TooltipModule,
    ButtonModule,
    InputTextModule,
    RippleModule,
    StyleClassModule,
    DatePicker
  ],
  providers: [
    PreviewData, CommonSetting,SignUp,
    // {
    //   provide: PreviewData,
    //   useValue: window['PreviewSetting']
    // },
    {
      provide: CommonSetting,
      useValue: window['CommonSetting']
    },
    {
      provide: SignUp,
      useValue: window['SignUp']
    },
    {
      provide: OfflineSurvey,
      useValue: window['OfflineSurvey']
    },
    {
      provide: ErrorHandler,
      useClass: CustomErrorsHandlerService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
